var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToggledislike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 5,
    stroke: "#FF3B30",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4073 7.66505V14.4384C14.4073 14.7051 14.3273 14.9651 14.1807 15.1851L12.3607 17.8917C12.074 18.3251 11.3607 18.6317 10.754 18.4051C10.1007 18.1851 9.66733 17.4517 9.80733 16.7984L10.154 14.6184C10.1807 14.4184 10.1273 14.2384 10.014 14.0984C9.90066 13.9717 9.73399 13.8917 9.554 13.8917H6.81399C6.28733 13.8917 5.83399 13.6784 5.56733 13.3051C5.31399 12.9451 5.26733 12.4784 5.43399 12.0051L7.07399 7.01172C7.28066 6.18505 8.18066 5.51172 9.074 5.51172H11.674C12.1207 5.51172 12.7473 5.66505 13.034 5.95172L13.8873 6.61172C14.214 6.86505 14.4073 7.25172 14.4073 7.66505Z",
    fill: "#FF3B30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5276 15.739H17.2142C18.2476 15.739 18.6676 15.339 18.6676 14.3523V7.65229C18.6676 6.66562 18.2476 6.26562 17.2142 6.26562H16.5276C15.4942 6.26562 15.0742 6.66562 15.0742 7.65229V14.359C15.0742 15.339 15.4942 15.739 16.5276 15.739Z",
    fill: "#FF3B30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggledislike);
export default __webpack_public_path__ + "static/media/toggledislike.5de3be2ee34abac79c4e0a410ca8a5c1.svg";
export { ForwardRef as ReactComponent };